import React from "react";
import { createElementClass } from "../helpers";
export var List = function List(_a) {
  var start = _a.start,
      ordered = _a.ordered,
      tight = _a.tight,
      depth = _a.depth,
      children = _a.children;

  if (ordered) {
    return React.createElement("ol", {
      className: createElementClass("list-ordered"),
      start: start
    }, children);
  }

  return React.createElement("ul", {
    className: createElementClass("list-unordered")
  }, children);
};